import { render, staticRenderFns } from "./ProjectShapeSchemaForm.vue?vue&type=template&id=6a68a2ec"
import script from "./ProjectShapeSchemaForm.vue?vue&type=script&lang=js"
export * from "./ProjectShapeSchemaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports